module.exports = __webpack_public_path__ + "img/ivTest_sub72.78059b2e.jpg";